import React, {PureComponent} from 'react';

import {getBrand} from '../../utils';
import './footer.css';

export default class Footer extends PureComponent{
    render(){
        var path = "https://integrations.circleloop.com/privacy";
        if (typeof window !== 'undefined') path = window.location.protocol + '//' + window.location.host + '/privacy';
        
        return (
            <footer className="white-footer">
                <div className="footer-container">
                    <img src="https://s3-eu-west-1.amazonaws.com/circleloop-assets/images/footer/uk-flag-footer.svg" alt="UK"/>
                    <p>UK</p><p>©{new Date().getFullYear()} {getBrand() === 'circleloop' ? 'CircleLoop' : 'CloudTalk'} All rights reserved | <a className="privacy-link" href={path}>Privacy Policy</a></p>
                </div>
            </footer>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer/index.js